

import React, { useEffect, useState } from 'react';
import "./manageusers.css";
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import HttpClient from '../utils/HttpClient';
import 'bootstrap/dist/css/bootstrap.min.css';
import toast from 'react-hot-toast';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input } from 'reactstrap';
import { Dropdown } from 'react-bootstrap';
import Swal from 'sweetalert2';
import noImg from "../Images/noImage.png"
const ManageUsers = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [allUsersList, setAllUsersList] = useState([]);
    const [activeRow, setActiveRow] = useState(null);
    const [isShow, setIsShow] = useState(false)
    const [editPassword, setEditPassword] = useState("")
    const [selectedUserId, setSelectedUserId] = useState("")
    const [showPassword, setShowPassword] = useState(false);

    // >>>>Fetch All Users Data<<<<
    const fetchAllUsers = async () => {
        const res = await HttpClient.requestData("user-list", "GET");
        if (res && res?.status) {
            const arr = res?.data?.map((ele, ind) => ({
                sl: ind + 1,
                name: `${ele?.firstName} ${ele?.lastName}`,
                emailID: ele?.emailID,
                organizationName: ele?.organizationName,
                address: ele?.address,
                image: <><img src={ele?.image ? ele?.image : noImg} style={{ width: "80px", height: "70px" }} className='p-2' alt="" /></>,
                status: ele?.status === "Active" ? <p style={{ color: "#33614C", fontWeight: "bold" }}>{ele?.status}</p> : <p style={{ color: "#bda800", fontWeight: "bold" }}>{ele?.status}</p>,
                action: ele,
            }));

            setAllUsersList(arr);
        } else {
            toast.error("Failed to fetch user data.");
        }
    };

    // Columns Definition
    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            sortable: true,
            wrap: true
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            wrap: true
        },
        {
            name: 'Email-ID',
            selector: row => row.emailID,
            sortable: true,
            wrap: true
        },
        {
            name: 'Organization-Name',
            selector: row => row.organizationName,
            sortable: true,
            wrap: true
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true,
            wrap: true
        },
        {
            name: 'Image',
            selector: row => row.image,
            sortable: true,
            wrap: true
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true
        },
        {
            name: 'Action',
            cell: row => (
                <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic" style={{ border: 'none', boxShadow: 'none', textDecoration: "none", color: "rgb(208, 38, 38)" }}>
                        <i className="fa-solid fa-ellipsis-v" style={{ cursor: 'pointer' }} onClick={() => handleIconClick(row.sl)}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="tooltip-modal">
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleEdit(row)}>Edit</Dropdown.Item>
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleDelete(row)}>Delete</Dropdown.Item>
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleActiveInactive(row, row?.action?.status === "Active" ? "Inactive" : "Active")}>{row.action?.status === "Active" ? "Inactive" : "Active"}</Dropdown.Item>
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleEditPassword(row?.action)}> <i className="fa-solid fa-pen-to-square mr-1"></i>Password</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            ),
            sortable: false,
            wrap: true,
        },
    ];

    // >>>>Search user by their name<<<<
    const searchUser = allUsersList.filter(data =>
        data?.name?.toLowerCase()?.includes(searchQuery.toLowerCase())
    );

    // >>>>Handle Showing Menu Modal<<<<
    const handleIconClick = (rowId) => {
        if (activeRow === rowId) {
            setActiveRow(null);
        } else {
            setActiveRow(rowId);
        }
    };

    // >>>>Handle Edit User<<<<
    const handleEdit = (row) => {
        navigate('/manageuserform', { state: row?.action })
    };

    // >>>>Handle Activ/Imactive user<<<<
    const handleActiveInactive = async (row, rowStatus) => {
        const id = row?.action?._id
        if (id && rowStatus) {
            const data = {
                status: rowStatus
            }
            console.log("Toggldfgdx", row, id, data);
            const res = await HttpClient.requestData(`user-status/${id}`, "PUT", data);
            if (res && res?.status) {
                toast.success(res?.message || "Status updated successfully...!");
                fetchAllUsers()
                setActiveRow(null)
            } else {
                return toast.error(res?.message || "Something went wrong...!")
            }
        }
    };

    // >>>>Handle Password Update Modal<<<<
    const handleEditPassword = (row) => {
        console.log("Editdfghc", row, row?.password);
        if (row) {
            setIsShow(true)
            setEditPassword(row?.password)
            setSelectedUserId(row?._id);
        } else {
            setIsShow(false)
            setEditPassword("")
            setSelectedUserId("");
        }
    };

    // >>>>Handle Update Password<<<<
    const handleUpdatePassword = async () => {
        const data = {
            password: editPassword
        }
        const res = await HttpClient.requestData(`change-password/${selectedUserId}`, "PUT", data);
        if (res && res?.status) {
            toast.success("Password updated successfully...!")
            fetchAllUsers();
            setIsShow(false)
            setEditPassword("")
            setSelectedUserId("");
            setActiveRow(null)
        } else {
            return toast.error(res?.message || "Something went wrong...!")
        }
    }

    // >>>>Handle Delete with SweetAlert confirmation<<<<
    const handleDelete = async (row) => {
        const id = row?.action?._id;
        if (id) {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            });

            if (result.isConfirmed) {
                const res = await HttpClient.requestData(`delete-user/${id}`, "DELETE");
                if (res && res.status) {
                    toast.success("User deleted successfully.");
                    fetchAllUsers();
                    setActiveRow(null)
                } else {
                    toast.error("Failed to delete item.");
                }
            }
        }
    };

    useEffect(() => {
        fetchAllUsers();
    }, []);

    return (
        <div className='manageUsers' style={{ position: 'relative' }}>

            {/* Heading */}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 0' }}>
                <h3 style={{ fontSize: '20px' }}>Manage Users</h3>
                <h3 style={{ fontSize: '15px', color: 'rgb(208, 38, 38)', cursor: 'pointer' }} onClick={() => navigate('/manageuserform')}>+ Add Users</h3>
            </div>

            {/* Search Input */}
            <div className="header-container Search_box d-flex justify-content-start p-2">
                <form className="form-inline" style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)" }} onSubmit={(e) => e.preventDefault()}>
                    <input
                        className="form-control"
                        type="search"
                        placeholder="Search by user name..."
                        aria-label="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button className="Search_icon" type="submit">
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                </form>
            </div>

            {/* DataTable */}
            <div className='mt-2 shadow-lg'>
                <DataTable
                    columns={columns}
                    data={searchUser}
                    pagination={true}
                    responsive={true}
                    highlightOnHover={true}
                />
            </div>

            {/* Edit Password Modal */}
            <Modal isOpen={isShow} toggle={() => setIsShow(false)}>
                <ModalHeader toggle={() => setIsShow(false)}>
                    Edit Password
                </ModalHeader>
                <ModalBody>
                    <div>
                        <label htmlFor="editPassword">Password</label>
                        <div style={{ position: 'relative' }}>
                            <Input
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter new password"
                                value={editPassword}
                                onChange={(e) => setEditPassword(e.target.value)}
                                style={{ paddingRight: '30px' }}
                            />
                            <i
                                className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                }}
                            ></i>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className='d-flex gap-2 w-100'>
                        <Button color="primary" className='w-50' onClick={handleUpdatePassword}>Update</Button>
                        <Button color="secondary" className='w-50' onClick={() => setIsShow(false)}>Cancel</Button>
                    </div>
                </ModalFooter>
            </Modal>

        </div>
    );
};

export default ManageUsers;
